import { createFeatureSelector, createSelector } from '@ngrx/store';
import { isNullOrUndefined } from '@uzurv/core';

import { DriverOnboardingProfileState } from './driver-onboarding-profile.reducer';

export const driverOnboardingProfileState = createFeatureSelector<DriverOnboardingProfileState>('driverProfile');

export const start = createSelector(driverOnboardingProfileState, (state: DriverOnboardingProfileState) => state.transitPrograms);

export const getDriver = createSelector(driverOnboardingProfileState, (state: DriverOnboardingProfileState) => state.driver);

export const getTransitProgramsByDriverId = createSelector(
  driverOnboardingProfileState,
  (state: DriverOnboardingProfileState) => state.transitProgramDrivers
);

export const getDriverAccountStatus = createSelector(
  driverOnboardingProfileState,
  (state: DriverOnboardingProfileState) => state.driverAccountStatus
);

export const getTransitProgramDriverDriverStatuses = createSelector(
  driverOnboardingProfileState,
  (state: DriverOnboardingProfileState) => state.transitProgramDriverStatuses
);

export const getDocuments = createSelector(driverOnboardingProfileState, (state: DriverOnboardingProfileState) => state.documents);

export const getSignatureRequests = createSelector(
  driverOnboardingProfileState,
  (state: DriverOnboardingProfileState) => state.signatureRequests
);

export const getOpenDocument = createSelector(driverOnboardingProfileState, state => state.openDocument);

export const getScreeningPackageStatus = createSelector(driverOnboardingProfileState, state => {
  return state.screeningPackageStatus;
});

export const getScreening = createSelector(driverOnboardingProfileState, state => {
  return state.screening;
});

export const getSubstanceScreening = createSelector(
  driverOnboardingProfileState,
  (state: DriverOnboardingProfileState) => state.substanceScreening
);

export const getMVROrderDetails = createSelector(driverOnboardingProfileState, state => state.mvrOrderDetails);

export const getOpenSignatureRequest = createSelector(driverOnboardingProfileState, state => state.openSignatureRequest);

export const openSidenavItem = createSelector(
  driverOnboardingProfileState,
  state =>
    !isNullOrUndefined(state.openDocument) ||
    !isNullOrUndefined(state.openSignatureRequest) ||
    !isNullOrUndefined(state.screeningPackageStatus)
);

export const getLoading = createSelector(driverOnboardingProfileState, (state: DriverOnboardingProfileState) => state.loading);
